import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { DaVinciService } from 'common/data';
class DaVinciStore extends BaseStore {
	constructor(rootStore) {
		super(new DaVinciService(rootStore.app.baasic.apiClient));
	}

	@action async getBusinessPartners(warehouseId, search) {
		const response = await this.service.getBusinessPartners(warehouseId, search);
		this.item = response.data;
		return response.data;
	}
}
export default DaVinciStore;
